<template><svg class="bank-ui-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path v-for="(path, index) in paths" :key="index" :d="path" /></svg></template>
<script>
const icons = {
    card: ['M3 4h18v16H3V4Z', 'M3 9h18M7 15h4'],
    bank: ['m2 8 10-6 10 6H2Z', 'M3 21h18M4 18h16M6 8v10M10 8v10M14 8v10M18 8v10'],
    refresh: ['M20 7a9 9 0 0 0-15-2L2 8', 'M2 3v5h5', 'M4 17a9 9 0 0 0 15 2l3-3', 'M22 21v-5h-5'],
    hidden: ['M3 10a10 10 0 0 0 18 0', 'M4 13 2 15M8 16l-1 3M12 17v3M16 16l1 3M20 13l2 2'],
    visible: ['M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Z', 'M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0'],
    chevron: ['m9 5 7 7-7 7'],
    check: ['m5 12 4 4L19 6'],
    close: ['m6 6 12 12M18 6 6 18'],
    empty: ['m3 9 9-4 9 4-9 4L3 9Z', 'm3 9-2 5 8 3 3-4 3 4 8-3-2-5', 'M4 16v3l8 3 8-3v-3M12 17v5', 'M7 3 6 1M17 3l1-2M12 3V1']
}
export default { props: { name: { type: String, required: true } }, computed: { paths() { return icons[this.name] || icons.card } } }
</script>
<style scoped>.bank-ui-icon { width: 24px; height: 24px; flex: 0 0 auto; vertical-align: middle; }</style>
